export default "__VITE_ASSET__1f3a8d92__"